import React, { useState, useEffect } from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { Link } from "react-router-dom";
import helperNumber from "../../../helpers/numbers";
import UserExample from "../user/UserExample";
import ListSitePublisher from "./ListSitePublisher";
import CategorySitePublisherTopic from "./CategorySitePublisherTopic";

export default function ListPublisher() {
  const checkSitePublisherThatHasUserCategory = (
    userCategory,
    sitePublisherCategories
  ) => {
    if (sitePublisherCategories.includes(userCategory)) {
      return true;
    }
    return false;
  };

  const removeSitePublisherThatHasUserCategory = (listSitePublisher) => {
    return listSitePublisher.filter((sitePublisher) => {
      if (
        !checkSitePublisherThatHasUserCategory(
          UserExample.category,
          sitePublisher.categories
        )
      ) {
        return sitePublisher;
      }
    });
  };

  const [searchInputText, setSearchInputText] = useState("");
  const [categorySitePublisherSelected, setCategorySitePublisherSelected] =
    useState(0);
  const [sitePublishers, setSitePublishers] = useState(() => {
    return removeSitePublisherThatHasUserCategory(ListSitePublisher);
  });

  useEffect(() => {
    setSitePublishers(
      removeSitePublisherThatHasUserCategory(getSitePublisherFromSearchInputs())
    );
  }, [searchInputText, categorySitePublisherSelected]);

  const getSitePublisherFromSearchInputs = () => {
    const sitePublisherThatHasSearchURL = getSitePublisherThatHasSearchURL();
    const sitePublisherThatHasCategorySelected =
      getSitePublisherThatHasCategorySelected();

    const sitePublisherSearch = [];
    for (const sitePublisherThatHasSearchURLItem of sitePublisherThatHasSearchURL) {
      for (const sitePublisherThatHasCategorySelectedItem of sitePublisherThatHasCategorySelected) {
        if (
          sitePublisherThatHasSearchURLItem.id ==
          sitePublisherThatHasCategorySelectedItem.id
        ) {
          sitePublisherSearch.push(sitePublisherThatHasSearchURLItem);
        }
      }
    }

    return sitePublisherSearch;
  };

  const getSitePublisherThatHasCategorySelected = () => {
    if (categorySitePublisherSelected == "0") {
      return ListSitePublisher;
    }
    return ListSitePublisher.filter((sitePublisher) => {
      if (sitePublisher.categories.includes(categorySitePublisherSelected)) {
        return sitePublisher;
      }
    });
  };

  const getSitePublisherThatHasSearchURL = () => {
    return ListSitePublisher.filter((sitePublisher) => {
      if (sitePublisher.url.includes(searchInputText)) {
        return sitePublisher;
      }
    });
  };

  const renderTooltip = (props) => (
    <Tooltip {...props}>
      <span style={{ fontFamily: "IRANSansWeb" }}>به زودی</span>
    </Tooltip>
  );

  const generateTagSitesPublisher = () => {
    return sitePublishers.map((sitePublisher, index) => {
      return (
        <tr key={index}>
          <td>{helperNumber.toPersianNum(index + 1)}</td>
          <td>
            <a href={sitePublisher.url} target="_blank">
              {sitePublisher.url}
            </a>
          </td>
          <td>{sitePublisher.categories.join(" - ")}</td>
          <td>
            <div className="d-flex justify-content-around">
              <span>
                <i className="fa fa-mobile-alt"></i>
              </span>
              <span>
                <i className="fa fa-desktop"></i>
              </span>
            </div>
          </td>
          <td>
            <Link
              to={`/publishers/preview/${sitePublisher.id}/all-page`}
              className="btn btn-info"
            >
              پیش نمایش جایگاه های نمایش تبلیغات
            </Link>
          </td>
        </tr>
      );
    });
  };

  const generateCategorySitePublisherTopic = () => {
    return CategorySitePublisherTopic.map((category) => {
      if (category.id != UserExample.category_id) {
        return <option>{category.title}</option>;
      }
    });
  };

  return (
    <>
      <div
        className="tab-pane fade show active border border-3 p-2 rounded"
        id="list-publisher"
        role="tabpanel"
        aria-labelledby="list-publisher-tab"
      >
        <div>
          <div className="d-flex  ">
            <div className="container-fluid">
              <div className="row  ">
                <div className="col-12 col-md-7 d-flex">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div>
                          <label>جستجو آدرس سایت</label>
                        </div>
                        <div>
                          <input
                            className="form-control"
                            id="site"
                            type="text"
                            onKeyUp={(e) => {
                              setSearchInputText(e.target.value);
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <div>
                          <div>
                            <label>انتخاب دسته بندی موضوع</label>
                          </div>
                          <div>
                            <select
                              id="categories-site-publishers"
                              className="form-control"
                              onChange={(e) => {
                                setCategorySitePublisherSelected(
                                  e.target.value
                                );
                              }}
                            >
                              <option value="0"> همه دسته بندی ها</option>
                              {generateCategorySitePublisherTopic()}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-5 ">
                  <div className="d-flex flex-wrap  ">
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-6 col-sm-3">
                          <div className="d-flex flex-column justify-content-between ">
                            <div className="pb-2">بنری</div>
                            <div>
                              <span>
                                <label className="adl-switch">
                                  <input
                                    disabled
                                    type="checkbox"
                                    checked={true}
                                  />
                                  <span className="adl-slider round"></span>
                                </label>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-6 col-sm-3">
                          <div className="d-flex flex-column justify-content-between ">
                            <div className="pb-2">همسان</div>
                            <OverlayTrigger
                              placement="top"
                              delay={{ show: 250, hide: 400 }}
                              overlay={renderTooltip}
                            >
                              <div>
                                <span>
                                  <label className="adl-switch">
                                    <input disabled type="checkbox" />
                                    <span className="adl-slider round"></span>
                                  </label>
                                </span>
                              </div>
                            </OverlayTrigger>
                          </div>
                        </div>
                        <div className="col-6 col-sm-3">
                          <div className="d-flex flex-column justify-content-between ">
                            <div className="pb-2">پوش</div>
                            <OverlayTrigger
                              placement="top"
                              delay={{ show: 250, hide: 400 }}
                              overlay={renderTooltip}
                            >
                              <div>
                                <span>
                                  <label className="adl-switch">
                                    <input disabled type="checkbox" />
                                    <span className="adl-slider round"></span>
                                  </label>
                                </span>
                              </div>
                            </OverlayTrigger>
                          </div>
                        </div>
                        <div className="col-6 col-sm-3">
                          <div className="d-flex flex-column justify-content-between ">
                            <div className="pb-2">محصول</div>
                            <OverlayTrigger
                              placement="top"
                              delay={{ show: 250, hide: 400 }}
                              overlay={renderTooltip}
                            >
                              <div>
                                <span>
                                  <label className="adl-switch">
                                    <input disabled type="checkbox" />
                                    <span className="adl-slider round"></span>
                                  </label>
                                </span>
                              </div>
                            </OverlayTrigger>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="table-responsive pt-3">
              <table className="table table-hilite tbl-td-white-space">
                <thead>
                  <tr>
                    <td>#</td>
                    <td>نمایش دهنده</td>
                    <td>دسته بندی موضوع</td>
                    <td>قابل نمایش در</td>
                    <td>نمایش صفحات</td>
                  </tr>
                </thead>
                <tbody>{generateTagSitesPublisher()}</tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
